import {Pipe, PipeTransform} from "@angular/core";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {Tidssone} from "../tjenester/ressurser/generertNg2HttpKlient";

@Pipe({name: 'tidssone', pure: true, standalone: true})
export class FormaterTidssonePipe implements PipeTransform {
    constructor() {
    }

    transform(value: Tidssone | null): string | null {
        return formater(value);
    }
}

function formater(tidssone: Tidssone | null) {
    if (erNil(tidssone)) return '';

    return tidssone;
}
